import { Button } from "@chakra-ui/button";
import { Box } from "@chakra-ui/layout";
import { Select, SelectProps, Modal } from "antd";
import useBlocoQuadra from "core/features/bloco/hooks/useBlocoQuadra";
import { useState, useEffect } from "react";
import SelectBaseAntd from "../SelectBaseAntd";
import FormBlocoQuadra from "./FormBlocoQuadra";

const { Option } = Select;

export interface SelectBlocoQuadraProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  tenantId: any;
  isInvalid?: boolean;
}

function SelectBlocoQuadra({
  value,
  onChange,
  tenantId,
  isInvalid,
  ...rest
}: SelectBlocoQuadraProps) {
  const { isLoading, isFetching, data, refetch } = useBlocoQuadra(tenantId, value);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [search, setSearch] = useState<string>();

  useEffect(() => {
    if (!isOpenModal) {
      setSearch("");
    }
  }, [isOpenModal]);

  return (
    <>
      <Modal
        visible={isOpenModal}
        footer={null}
        onCancel={() => setIsOpenModal(false)}
      >
        <Box>
          {isOpenModal ? (
            <FormBlocoQuadra
              visible={isOpenModal}
              tenantId={tenantId}
              defaultValue={{ nome: search as string, tenantId }}
              onClose={() => setIsOpenModal(false)}
              onSuccess={async (id) => {
                onChange(id);

                await refetch();

                setIsOpenModal(false);
              }}
            />
          ) : null}
        </Box>
      </Modal>

      <SelectBaseAntd
        isInvalid={isInvalid}
        loading={isLoading || isFetching}
        size="large"
        placeholder="Bloco/Quadra"
        style={{ width: "100%" }}
        value={value}
        onChange={onChange}
        {...rest}
        showSearch
        searchValue={search}
        onSearch={(v) => {
          if (!isOpenModal) {
            setSearch(v);
          }
        }}
        notFoundContent={
          <Box>
            Nada encontrado!!{" "}
            <Button
              leftIcon={<i className="mdi mdi-plus" />}
              size="xs"
              colorScheme="orange"
              onClick={() => setIsOpenModal(true)}
            >
              cadastrar novo
            </Button>
          </Box>
        }
      >
        {data?.items.map((item: any) => (
          <Option value={item.id} key={item.id}>
            {item.nome}
          </Option>
        ))}
      </SelectBaseAntd>
    </>
  );
}

export default SelectBlocoQuadra;
